import {
    AwardIcon,
    BabyIcon,
    BadgeCheckIcon,
    BedDoubleIcon,
    BedSingleIcon,
    BellIcon,
    BicepsFlexedIcon,
    BirdIcon,
    BlendIcon,
    BlindsIcon,
    BlocksIcon,
    BluetoothIcon,
    BookIcon,
    BookHeartIcon,
    BookImageIcon,
    BookOpenIcon,
    BookmarkIcon,
    BookmarkCheckIcon,
    BoomBoxIcon,
    BoxIcon,
    BoxesIcon,
    BrainCogIcon,
    BrickWallIcon,
    BrushIcon,
    BubblesIcon,
    BugIcon,
    CalendarClockIcon,
    CalendarHeartIcon,
    CameraIcon,
    CatIcon,
    ChartSplineIcon,
    CheckIcon,
    CheckCheckIcon,
    ChevronsUpIcon,
    CircleIcon,
    CircleCheckBigIcon,
    CirclePowerIcon,
    CircleUserRoundIcon,
    CircleStopIcon,
    CloudMoonIcon,
    CloudSunIcon,
    ComponentIcon,
    ConciergeBellIcon,
    Dice5Icon,
    DicesIcon,
    DogIcon,
    DramaIcon,
    DrumIcon,
    DumbbellIcon,
    EarIcon,
    EarOffIcon,
    EarthIcon,
    EqualApproximatelyIcon,
    EqualIcon,
    EyeIcon,
    EyeClosedIcon,
    FeatherIcon,
    FastForwardIcon,
    FingerprintIcon,
    FishIcon,
    FlashlightIcon,
    FlowerIcon,
    Flower2Icon,
    FrownIcon,
    Gamepad2Icon,
    GemIcon,
    GlassesIcon,
    HandIcon,
    HandshakeIcon,
    HazeIcon,
    HeadphonesIcon,
    HeartIcon,
    HeartPulseIcon,
    HighlighterIcon,
    HourglassIcon,
    ImageIcon,
    InfinityIcon,
    LampIcon,
    LampFloorIcon,
    LaughIcon,
    LoaderIcon,
    MehIcon,
    MessageCircleIcon,
    MessageCircleHeartIcon,
    MessageCircleMoreIcon,
    MessageCircleQuestionIcon,
    MessageSquareIcon,
    MicVocalIcon,
    MoonIcon,
    MoonStarIcon,
    MusicIcon,
    Music2Icon,
    PackageIcon,
    PaletteIcon,
    PandaIcon,
    PartyPopperIcon,
    PauseIcon,
    PawPrintIcon,
    PersonStandingIcon,
    PianoIcon,
    PlayIcon,
    PowerIcon,
    ProjectorIcon,
    PuzzleIcon,
    RabbitIcon,
    ScaleIcon,
    SearchIcon,
    ShellIcon,
    ShipWheelIcon,
    SignalIcon,
    SirenIcon,
    SlidersHorizontalIcon,
    SmileIcon,
    SnowflakeIcon,
    SparkleIcon,
    SparklesIcon,
    SpeechIcon,
    SprayCanIcon,
    SproutIcon,
    StarIcon,
    SunIcon,
    SunMoonIcon,
    SunriseIcon,
    TentIcon,
    ThermometerIcon,
    ThermometerSunIcon,
    ThermometerSnowflakeIcon,
    TrophyIcon,
    TruckIcon,
    UserCheckIcon,
    UsersIcon,
    VolleyballIcon,
    VideoIcon,
    Volume2Icon,
    WandIcon,
    WandSparklesIcon,
    WatchIcon,
    WavesIcon,
    WifiIcon,
    WindIcon,
    WrenchIcon,
    ZapIcon,
    LightbulbIcon,
    AudioLinesIcon,
} from 'lucide-vue-next';

export const icons: { [key: string]: Component } = {
    'lightbulb': LightbulbIcon,
    'bubbles': BubblesIcon,
    'audio-lines': AudioLinesIcon,
    'award': AwardIcon,
    'baby': BabyIcon,
    'badge-check': BadgeCheckIcon,
    'bed-double': BedDoubleIcon,
    'bed-single': BedSingleIcon,
    'bell': BellIcon,
    'biceps-flexed': BicepsFlexedIcon,
    'bird': BirdIcon,
    'blend': BlendIcon,
    'blinds': BlindsIcon,
    'blocks': BlocksIcon,
    'bluetooth': BluetoothIcon,
    'book': BookIcon,
    'book-heart': BookHeartIcon,
    'book-image': BookImageIcon,
    'book-open': BookOpenIcon,
    'bookmark': BookmarkIcon,
    'bookmark-check': BookmarkCheckIcon,
    'boom-box': BoomBoxIcon,
    'box': BoxIcon,
    'boxes': BoxesIcon,
    'brain-cog': BrainCogIcon,
    'brick-wall': BrickWallIcon,
    'brush': BrushIcon,
    'bug': BugIcon,
    'calendar-clock': CalendarClockIcon,
    'calendar-heart': CalendarHeartIcon,
    'camera': CameraIcon,
    'cat': CatIcon,
    'chart-spline': ChartSplineIcon,
    'check': CheckIcon,
    'check-check': CheckCheckIcon,
    'chevrons-up': ChevronsUpIcon,
    'circle': CircleIcon,
    'circle-check-big': CircleCheckBigIcon,
    'circle-power': CirclePowerIcon,
    'circle-user-round': CircleUserRoundIcon,
    'circle-stop': CircleStopIcon,
    'cloud-moon': CloudMoonIcon,
    'cloud-sun': CloudSunIcon,
    'component': ComponentIcon,
    'concierge-bell': ConciergeBellIcon,
    'dice-5': Dice5Icon,
    'dices': DicesIcon,
    'dog': DogIcon,
    'drama': DramaIcon,
    'drum': DrumIcon,
    'dumbell': DumbbellIcon,
    'ear': EarIcon,
    'ear-off': EarOffIcon,
    'earth': EarthIcon,
    'equal-approximately': EqualApproximatelyIcon,
    'equal': EqualIcon,
    'eye': EyeIcon,
    'eye-closed': EyeClosedIcon,
    'feather': FeatherIcon,
    'fast-forward': FastForwardIcon,
    'fingerprint': FingerprintIcon,
    'fish': FishIcon,
    'flashlight': FlashlightIcon,
    'flower': FlowerIcon,
    'flower-2': Flower2Icon,
    'frown': FrownIcon,
    'gamepad-2': Gamepad2Icon,
    'gem': GemIcon,
    'glasses': GlassesIcon,
    'hand': HandIcon,
    'handshake': HandshakeIcon,
    'haze': HazeIcon,
    'headphones': HeadphonesIcon,
    'heart': HeartIcon,
    'hear-pulse': HeartPulseIcon,
    'highlighter': HighlighterIcon,
    'hourglass': HourglassIcon,
    'image': ImageIcon,
    'infinity': InfinityIcon,
    'lamp': LampIcon,
    'lamp-floor': LampFloorIcon,
    'laugh': LaughIcon,
    'loader': LoaderIcon,
    'meh': MehIcon,
    'message-circle': MessageCircleIcon,
    'message-circle-heart': MessageCircleHeartIcon,
    'message-circle-more': MessageCircleMoreIcon,
    'message-circle-question': MessageCircleQuestionIcon,
    'message-square': MessageSquareIcon,
    'mic-vocal': MicVocalIcon,
    'moon': MoonIcon,
    'moon-star': MoonStarIcon,
    'music': MusicIcon,
    'music-2': Music2Icon,
    'package': PackageIcon,
    'palette': PaletteIcon,
    'panda': PandaIcon,
    'party-popper': PartyPopperIcon,
    'pause': PauseIcon,
    'paw-print': PawPrintIcon,
    'person-standing': PersonStandingIcon,
    'piano': PianoIcon,
    'play': PlayIcon,
    'power': PowerIcon,
    'projector': ProjectorIcon,
    'puzzle': PuzzleIcon,
    'rabbit': RabbitIcon,
    'scale': ScaleIcon,
    'search': SearchIcon,
    'shell': ShellIcon,
    'ship-wheel': ShipWheelIcon,
    'signal': SignalIcon,
    'siren': SirenIcon,
    'sliders-horizontal': SlidersHorizontalIcon,
    'smile': SmileIcon,
    'snowflake': SnowflakeIcon,
    'sparkle': SparkleIcon,
    'sparkles': SparklesIcon,
    'speech': SpeechIcon,
    'spray-can': SprayCanIcon,
    'sprout': SproutIcon,
    'star': StarIcon,
    'sun': SunIcon,
    'sun-moon': SunMoonIcon,
    'sunrise': SunriseIcon,
    'tent': TentIcon,
    'thermometer': ThermometerIcon,
    'thermometer-sun': ThermometerSunIcon,
    'thermometer-snowflake': ThermometerSnowflakeIcon,
    'trophy': TrophyIcon,
    'truck': TruckIcon,
    'user-check': UserCheckIcon,
    'users': UsersIcon,
    'volleyball': VolleyballIcon,
    'video': VideoIcon,
    'volume-2': Volume2Icon,
    'wand': WandIcon,
    'wand-sparkles': WandSparklesIcon,
    'watch': WatchIcon,
    'waves': WavesIcon,
    'wifi': WifiIcon,
    'wind': WindIcon,
    'wrench': WrenchIcon,
    'zap': ZapIcon,
}
